// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PHQkt","label":"styles_label__3XN5B"};